import React from 'react';

import clsx from 'clsx';

const Button = ({children, className, type, onClick, disabled}) => (
  <button className={clsx("button", className)} type={type} onClick={onClick} disabled={disabled}>
    {children}
  </button>
)

export default Button;